/**
     * @desc 获取同声传译状态
可能产生业务错误码：510001、510002
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/meeting/interpret', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/interpret',
    params,
    swrOptions,
  );
}

export function request(params: Params, body: number, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/meeting/interpret', params, 'GET'),
    {
      method: 'GET',

      body,
      ...options,
    },
  );
}
